/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Your_StoryInputs */

const en_story_your_story = /** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your Story`)
};

const es_story_your_story = /** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu Historia`)
};

const fr_story_your_story = /** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre Story`)
};

const de_story_your_story = /** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Story`)
};

const id_story_your_story = /** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerita Anda`)
};

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const ja_story_your_story = en_story_your_story;

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const zh_story_your_story = en_story_your_story;

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const ar_story_your_story = en_story_your_story;

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const it_story_your_story = en_story_your_story;

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const ru_story_your_story = en_story_your_story;

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const pt_story_your_story = en_story_your_story;

/** @type {(inputs: Story_Your_StoryInputs) => LocalizedString} */
const ko_story_your_story = en_story_your_story;

/**
* | output |
* | --- |
* | "Your Story" |
*
* @param {Story_Your_StoryInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_your_story = /** @type {((inputs?: Story_Your_StoryInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Your_StoryInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_your_story(inputs)
	if (locale === "es") return es_story_your_story(inputs)
	if (locale === "fr") return fr_story_your_story(inputs)
	if (locale === "de") return de_story_your_story(inputs)
	if (locale === "ja") return ja_story_your_story(inputs)
	if (locale === "zh") return zh_story_your_story(inputs)
	if (locale === "ar") return ar_story_your_story(inputs)
	if (locale === "id") return id_story_your_story(inputs)
	if (locale === "it") return it_story_your_story(inputs)
	if (locale === "ru") return ru_story_your_story(inputs)
	if (locale === "pt") return pt_story_your_story(inputs)
	return ko_story_your_story(inputs)
});